import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import FormattedText from './FormattedText';
import { CASE_STUDIES } from '../data';
import { fetchCaseStudyPreviews } from '../lib/contentful/services/caseStudies';
import './CaseStudies.css';

export default function CaseStudies() {
  const fallbackPreviews = useMemo(
    () =>
      CASE_STUDIES.map(cs => ({
        id: cs.id,
        tag: cs.tag,
        title: cs.title,
        summary: cs.summary,
      })),
    []
  );
  const [caseStudies, setCaseStudies] = useState(fallbackPreviews);

  useEffect(() => {
    let isActive = true;

    async function loadCaseStudyPreviews() {
      try {
        const previews = await fetchCaseStudyPreviews();
        if (!isActive || !previews.length) return;
        setCaseStudies(previews);
      } catch {
        // Keep local fallback content if Contentful is unavailable.
      }
    }

    loadCaseStudyPreviews();

    return () => {
      isActive = false;
    };
  }, []);

  return (
    <section className="case-studies" id="case-studies">
      <div className="container">
        <div className="case-studies__header">
          <span className="section-eyebrow">Selected Work</span>
          <h2 className="section-title">Case Studies</h2>
          <p className="case-studies__intro">
            Real results from complex martech challenges.
          </p>
        </div>

        <div className="case-studies__list">
          {caseStudies.map((cs, i) => (
            <div key={cs.id} className="cs-card">
              <div className="cs-card__number">{String(i + 1).padStart(2, '0')}</div>
              <div className="cs-card__body">
                <span className="cs-card__tag">{cs.tag}</span>
                <h3 className="cs-card__title">{cs.title}</h3>
                <FormattedText as="p" className="cs-card__summary" text={cs.summary} />
              </div>
              <div className="cs-card__action">
                <Link to={`/case-studies/${cs.id}`} className="btn-outline">
                  Learn More
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
